import { c as _c } from "react/compiler-runtime";
import MainTitle from '@pc/components/atoms/typograph/MainTitle';
import BroadcastUserItemSkeleton from '../../list/broadcast/BroadcastUserItemSkeleton';
import BroadcastUserList from '../../list/broadcast/BroadcastUserList';
interface Props {
  itemLength?: number;
  title?: string;
}
function BroadcastListSkeleton(t0) {
  const $ = _c(9);
  const {
    itemLength: t1,
    title
  } = t0;
  const itemLength = t1 === undefined ? 15 : t1;
  let t2;
  if ($[0] !== title) {
    t2 = title && <MainTitle>{title}</MainTitle>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== itemLength) {
    t3 = Array.from({
      length: itemLength
    })?.map(_temp);
    $[2] = itemLength;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <BroadcastUserList>{t3}</BroadcastUserList>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp(_, idx) {
  return <BroadcastUserItemSkeleton key={Number(idx)} />;
}
export default BroadcastListSkeleton;